/**
 * Global modal id for the "Manage Columns" modal.
 *
 * Registered last in GLOBAL_MODAL_IDS so it stacks above entity detail modals.
 * Kept in its own module so non-component call sites (e.g. the column-header
 * context menu) can open the modal via `useGlobalModalStack().openModal(...)`
 * without importing the whole SimpleColumnManager component.
 */
export const MANAGE_TABLE_COLUMNS_MODAL_ID = "manage-table-columns";
